import { render, staticRenderFns } from "./NPCNameDialog.vue?vue&type=template&id=f99cce40&"
import script from "./NPCNameDialog.vue?vue&type=script&lang=js&"
export * from "./NPCNameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports